module.exports = __webpack_public_path__ + "static/media/S34_W.efb85e5e.png";